(function () {
  const MOBILE_INFINITE_BATCH_SIZE = 24;
  const MOBILE_INFINITE_TRIGGER_PX = 24;
  const mobileInfiniteState = {
    isLoading: false,
    hasMore: true,
    page: 1
  };
  let infiniteLoaderEl = null;

  function byId(id) {
    return document.getElementById(id);
  }

  function isMobileGridMode() {
    return window.innerWidth <= 768;
  }

  function resetMobileInfiniteState() {
    mobileInfiniteState.isLoading = false;
    mobileInfiniteState.hasMore = true;
    mobileInfiniteState.page = 1;
    if (infiniteLoaderEl) {
      infiniteLoaderEl.style.display = "none";
    }
  }

  function ensureInfiniteLoader() {
    if (infiniteLoaderEl) return infiniteLoaderEl;
    const grid = byId("league-grid");
    if (!grid || !grid.parentNode) return null;
    const loader = document.createElement("div");
    loader.id = "leagueInfiniteLoader";
    loader.className = "infinite-scroll-loading";
    loader.textContent = "Loading more leagues...";
    loader.style.display = "none";
    grid.insertAdjacentElement("afterend", loader);
    infiniteLoaderEl = loader;
    return loader;
  }

  function setInfiniteLoaderVisible(visible) {
    const loader = ensureInfiniteLoader();
    if (!loader) return;
    loader.style.display = visible ? "flex" : "none";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function toArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function normalizeDetailBasePath(value) {
    const raw = String(value || "").trim();
    if (!raw) return "/pages/leagues";
    const withoutTrailingSlashes = raw.replace(/\/+$/, "");
    return withoutTrailingSlashes || "/pages/leagues";
  }

  function toImageUrl(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw)) return raw;
    return "";
  }

  function toFiniteNumber(value) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }

  function formatCurrency(value) {
    const num = toFiniteNumber(value);
    if (num === null) return "";
    if (Number.isInteger(num)) return `$${num}`;
    return `$${num.toFixed(2)}`;
  }

  function getLeagueDivisions(league) {
    const topLevel = toArray(league && league.divisions);
    if (topLevel.length) return topLevel;
    const specDivisions = toArray(league && league.specificationData && league.specificationData.leagues && league.specificationData.leagues.divisions);
    return specDivisions;
  }

  function getDivisionLocationCount(divisions) {
    const locationIds = new Set();
    toArray(divisions).forEach(function (division) {
      const divisionLocationIds = Array.isArray(division && division.locationIds)
        ? division.locationIds
        : (Array.isArray(division && division.location_ids) ? division.location_ids : []);
      divisionLocationIds.forEach(function (locationId) {
        const normalized = String(locationId || "").trim();
        if (normalized) locationIds.add(normalized);
      });
    });
    return locationIds.size;
  }

  function getDivisionFeeValues(divisions, keys) {
    const values = [];
    divisions.forEach(function (division) {
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const value = toFiniteNumber(division && division[key]);
        if (value !== null) {
          values.push(value);
          break;
        }
      }
    });
    return values;
  }

  function summarizeFees(label, values, fallbackValue) {
    const divisionValues = toArray(values).filter(function (value) {
      return toFiniteNumber(value) !== null;
    }).map(function (value) { return Number(value); });
    if (divisionValues.length) {
      const min = Math.min.apply(null, divisionValues);
      const max = Math.max.apply(null, divisionValues);
      if (min === max) {
        return `${label}: ${formatCurrency(min)}`;
      }
      return `${label}: ${formatCurrency(min)}-${formatCurrency(max)}`;
    }
    const fallback = toFiniteNumber(fallbackValue);
    if (fallback !== null) {
      return `${label}: ${formatCurrency(fallback)}`;
    }
    return "";
  }

  function getCurrentPage() {
    const params = new URLSearchParams(window.location.search || "");
    const value = Number.parseInt(String(params.get("page") || "1"), 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function hasActiveFilters() {
    const params = new URLSearchParams(window.location.search || "");
    const keys = ["searchQuery", "q", "state", "city"];
    return keys.some(function (key) {
      const value = params.get(key);
      return Boolean(value && String(value).trim());
    });
  }

  function hydrateFilterOptionsFromWindow() { }

  function renderCards(items, detailBasePath, options) {
    const append = options && options.append === true;
    const grid = byId("league-grid");
    const count = byId("league-results-count");
    if (!grid || !count) return;

    if (!append) {
      count.textContent = `${items.length} Leagues`;
    } else {
      const existing = Number.parseInt(String(count.textContent || "0").replace(/\D/g, ""), 10);
      const next = (Number.isFinite(existing) ? existing : 0) + items.length;
      count.textContent = `${next} Leagues`;
    }

    if (!items.length) {
      if (!append) {
        grid.innerHTML = '<div class="hd-empty">No leagues found.</div>';
      }
      return;
    }

    const cardsHtml = items
      .map(function (league) {
        const divisions = getLeagueDivisions(league);
        const divisionCount = divisions.length;
        const divisionLocationCount = getDivisionLocationCount(divisions);
        const profileTypes = toArray(league.profileTypes)
          .map(function (value) {
            return `<span class="league-pill">${escapeHtml(value)}</span>`;
          })
          .join("");

        const annualValues = getDivisionFeeValues(divisions, ["annualMembershipFee", "annual_membership_fee"]);
        const matchValues = getDivisionFeeValues(divisions, ["matchFee", "match_fee"]);
        const feeBits = [
          summarizeFees("Annual", annualValues, league.annualMembershipFee),
          summarizeFees("Match", matchValues, league.matchFee),
        ].filter(Boolean);

        const galleryUrls = toArray(league.galleryUrls).map(toImageUrl).filter(Boolean);
        const galleryItems = toArray(league.gallery)
          .map(function (item) {
            return toImageUrl(item && item.url);
          })
          .filter(Boolean);
        const imageUrl = galleryUrls[0] || galleryItems[0] || "";
        const imageMarkup = imageUrl
          ? `<div class="league-card-media"><img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(league.title || 'League image')}" loading="lazy" decoding="async"></div>`
          : `<div class="league-card-media league-card-media--placeholder" aria-hidden="true"></div>`;

        return `
          <article class="league-card">
            ${imageMarkup}
            <h3 class="league-card-title">${escapeHtml(league.title)}</h3>
            <div>${profileTypes || ""}</div>
            ${divisionCount > 0 ? `<div class="league-card-meta">${divisionCount} ${divisionCount === 1 ? "division" : "divisions"}</div>` : ""}
            ${divisionCount > 0 ? `<div class="league-card-meta">${divisionLocationCount} ${divisionLocationCount === 1 ? "location" : "locations"}</div>` : ""}
            <div class="league-card-meta">${escapeHtml(feeBits.join(" • "))}</div>
            <a class="league-card-link" href="${detailBasePath}/${encodeURIComponent(league.slug || league.id)}">View League</a>
          </article>
        `;
      })
      .join("");

    if (append) {
      grid.insertAdjacentHTML("beforeend", cardsHtml);
    } else {
      grid.innerHTML = cardsHtml;
    }
  }

  function renderPagination(pagination) {
    const container = byId("league-pagination");
    if (!container) return;

    if (isMobileGridMode()) {
      container.innerHTML = "";
      return;
    }

    const totalPagesRaw = Number(pagination?.totalPages);
    if (!Number.isFinite(totalPagesRaw)) {
      return;
    }

    const currentPage = Math.max(1, Number(pagination?.page) || 1);
    const totalPages = Math.max(1, totalPagesRaw);

    if (totalPages <= 1) {
      container.innerHTML = "";
      return;
    }

    let html = '';
    if (currentPage > 1) {
      const prevParams = new URLSearchParams(window.location.search || "");
      prevParams.set("page", String(currentPage - 1));
      html += `<a href="${window.location.pathname}?${prevParams.toString()}" class="pagination-button">Previous</a>`;
    } else {
      html += '<button class="pagination-button" disabled>Previous</button>';
    }

    for (let i = 1; i <= totalPages; i += 1) {
      const pageParams = new URLSearchParams(window.location.search || "");
      pageParams.set("page", String(i));
      html += `<a href="${window.location.pathname}?${pageParams.toString()}" class="pagination-link ${i === currentPage ? 'is-active' : ''}">${i}</a>`;
    }

    if (currentPage < totalPages) {
      const nextParams = new URLSearchParams(window.location.search || "");
      nextParams.set("page", String(currentPage + 1));
      html += `<a href="${window.location.pathname}?${nextParams.toString()}" class="pagination-button">Next</a>`;
    } else {
      html += '<button class="pagination-button" disabled>Next</button>';
    }

    container.innerHTML = html;
  }

  async function fetchLeagues(pageArg, options) {
    const append = options && options.append === true;
    const root = byId("league-listing-root");
    if (!root) return;

    const listingSlug = root.getAttribute("data-listing-slug") || "leagues";
    const detailBasePath = normalizeDetailBasePath(root.getAttribute("data-detail-base") || "/pages/leagues/");

    const params = new URLSearchParams();
    params.set("app", "get-leagues");
    params.set("listingSlug", listingSlug);

    const search = byId("heroSearchInput") || byId("league-search-input");
    const state = byId("league-state-filter");
    const city = byId("league-city-filter");

    if (search && search.value.trim()) params.set("searchQuery", search.value.trim());
    if (state && state.value.trim()) params.set("state", state.value.trim());
    if (city && city.value.trim()) params.set("city", city.value.trim());
    const pageToLoad = pageArg || getCurrentPage();
    params.set("page", String(pageToLoad));
    if (isMobileGridMode()) {
      params.set("per_page", String(MOBILE_INFINITE_BATCH_SIZE));
    }

    if (append && isMobileGridMode()) {
      setInfiniteLoaderVisible(true);
    }
    try {
      const response = await fetch(`/a/app?${params.toString()}`, { method: "GET", cache: "no-store" });
      const data = await response.json();

      if (!response.ok || !data?.success) {
        throw new Error(data?.error || "Failed to load leagues");
      }

      const leagues = toArray(data.leagues);
      renderCards(leagues, detailBasePath, { append: append });
      mobileInfiniteState.page = Number(data?.pagination?.page) || Number(pageToLoad) || 1;

      if (data.pagination && Number.isFinite(Number(data.pagination.totalPages))) {
        mobileInfiniteState.hasMore = Number(data.pagination.page) < Number(data.pagination.totalPages);
      } else {
        mobileInfiniteState.hasMore = leagues.length >= MOBILE_INFINITE_BATCH_SIZE;
      }

      renderPagination(data.pagination || {});

      const meta = data?.listingPage?.filterMetadata || {};
      if (meta && typeof meta === "object") {
        window.leagueFilterMetadata = meta;
        hydrateFilterOptionsFromWindow();
      }
    } finally {
      if (append && isMobileGridMode()) {
        setInfiniteLoaderVisible(false);
      }
    }
  }

  function boot() {
    const root = byId("league-listing-root");
    if (!root) return;

    hydrateFilterOptionsFromWindow();

    const controls = [
      "heroSearchInput",
      "league-state-filter",
      "league-city-filter",
    ];

    controls.forEach(function (id) {
      const node = byId(id);
      if (!node) return;
      node.addEventListener("change", function () {
        const url = new URL(window.location.href);
        url.searchParams.set("page", "1");
        window.history.replaceState({}, "", url.toString());
        resetMobileInfiniteState();
        fetchLeagues().catch(function (error) {
          console.error(error);
        });
      });
      if (id === "heroSearchInput") {
        node.addEventListener("keyup", function (event) {
          if (event.key === "Enter") {
            const url = new URL(window.location.href);
            url.searchParams.set("page", "1");
            window.history.replaceState({}, "", url.toString());
            resetMobileInfiniteState();
            fetchLeagues().catch(function (error) {
              console.error(error);
            });
          }
        });
      }
    });

    const maybeLoadMoreLeagues = function () {
      if (!isMobileGridMode()) return;
      if (mobileInfiniteState.isLoading || !mobileInfiniteState.hasMore) return;
      const docHeight = document.documentElement.scrollHeight;
      const maxScrollY = Math.max(0, docHeight - window.innerHeight);
      const triggerScrollY = Math.max(MOBILE_INFINITE_TRIGGER_PX, maxScrollY * 0.4);
      if (window.scrollY < triggerScrollY) return;

      mobileInfiniteState.isLoading = true;
      const nextPage = mobileInfiniteState.page + 1;
      fetchLeagues(nextPage, { append: true })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          mobileInfiniteState.isLoading = false;
        });
    };

    let scrollTimer;
    const debouncedLoad = function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(maybeLoadMoreLeagues, 120);
    };
    window.addEventListener("scroll", debouncedLoad, { passive: true });
    window.addEventListener("resize", debouncedLoad);

    // Always hydrate cards from backend so multi-location league metadata stays accurate.
    fetchLeagues().catch(function (error) {
      console.error(error);
      const grid = byId("league-grid");
      if (grid) {
        grid.innerHTML = `<div class="hd-error">${escapeHtml(error.message || "Failed to load leagues")}</div>`;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
